import {sendFieldsData} from '../api/api';
import {IGetFieldValueServiceArgs, ISaveActionServiceArgs} from '../model/types';

export const PostButtonService = {
    saveAction: async ({url, fieldKey, fieldValue}: ISaveActionServiceArgs) => {
        try {
            const response = await sendFieldsData({
              url,
              data: {
                [fieldKey]: fieldValue,
              },
            });

            return {response, isError: false};
        } catch (error) {
            console.error(error);
            return {response: error.response, isError: true};
        }
    },
    getFieldValue: ({form, fieldKey}: IGetFieldValueServiceArgs) => form.getFieldValue(fieldKey),
};
